'use client';

import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';
import {
  RecoveryHeroSection,
  RecoveryThemeTransition,
  RecoveryTreatmentsSection,
  RecoveryPassesSection,
  PlansSection,
  PincodeCtaBannerSection,
  GetDirectionsSection,
  PL_COLOR_BG,
  TextRevealSection,
  RecoveryImageCarousel,
} from 'components/performance-lab';
import { RECOVERY_PAGE_PARALLAX_BG } from 'components/performance-lab/recoveryPageAssets';

const TestimonialsSection = dynamic(
  () =>
    import('components/performance-lab/TestimonialsSection').then(
      (mod) => mod.TestimonialsSection,
    ),
  { ssr: false },
);

const PerformanceLabRecoveryPage = () => {
  const t = useTranslations('performance-lab');

  return (
    <>
      <RecoveryHeroSection />
      <TextRevealSection
        ariaLabel={t('recoveryPage.textReveal.aria')}
        bodyText={t('recoveryPage.textReveal.body')}
        backgroundColor="#000"
        textColor="#fff"
        scrollTrackVhMobile={2}
        scrollTrackVhDesktop={3}
        bookTourScrollAnchor
      />
      <RecoveryThemeTransition>
        <RecoveryImageCarousel />
        <RecoveryTreatmentsSection />
      </RecoveryThemeTransition>
      <TextRevealSection
        ariaLabel={t('recoveryPage.fixedBg.aria')}
        imageOnly
        scrollEnterVhMobile={0}
        scrollEnterVhDesktop={0}
        scrollExitVhMobile={0}
        scrollExitVhDesktop={0}
        scrollTrackVhMobile={1}
        scrollTrackVhDesktop={1}
        backgroundColor={PL_COLOR_BG}
        backgroundImage={RECOVERY_PAGE_PARALLAX_BG}
        clipOverflow
        fixedBackgroundScroll
      />
      <RecoveryPassesSection />
      <PlansSection variant="recovery" />
      <TestimonialsSection />
      <PincodeCtaBannerSection />
      <GetDirectionsSection />
    </>
  );
};

export default PerformanceLabRecoveryPage;
